// css =>
import "../../BaseStructure.css";
import Styled from "./product-box.module.css";

// context =>
import { useTheme } from '../../context/theme-context';

const ProductBox = (props) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={`col-6 ${ Styled.product_box_section } `}>
            <div
                className={`row ${ Styled.product_box }`}
                style={{
                    background: theme === "day" ? "linear-gradient(to top, #C9CCC2, #E5E5E5)" : ""
                }}>
                <div className="col-12">
                    <img src={ props.productPicture } alt={ props.productName } />
                </div>

                <div className="col-12">
                    <p
                        style={{
                            color: theme === "day" ? "#000000" : ""
                        }}
                    >{ props.productName }</p>
                </div>
            </div>
        </div>
    );
}

export default ProductBox;
